import script from "./PolicyConfigurationApplications.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyConfigurationApplications.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyConfigurationApplications.vue?vue&type=style&index=0&id=6518cc7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6518cc7a"]])

export default __exports__